import { FC, useState, ButtonHTMLAttributes } from "react"
import GoogleLogin from "@leecheuk/react-google-login"
import clsx from "clsx"
import { flex_center } from "@constants/styles"
import AuthServices from "@lib/api/services/auth.services"
import { Spinner } from "@components/misc"
import Image from "next/image"

export interface GoogleLoginProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  redirect?: string
  handleError: (a: string) => void
}

export const GoogleLoginButton: FC<GoogleLoginProps> = ({ redirect, handleError }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const auth = new AuthServices()

  async function handleGoogleLogin(response: any) {
    const userProfile = response.profileObj
    const userFullname = userProfile.name
    const userEmail = userProfile.email
    const googleId = userProfile.googleId

    setIsSubmitting(true)

    try {
      handleError("")

      const res = await auth.googleLogin({
        email: userEmail,
        fullName: userFullname,
        googleId,
      })

      if (res.isFailure) {
        setIsSubmitting(false)
        const errorMessage = res.error.message
        handleError(errorMessage)
      } else {
        if (!redirect) {
          window.location.reload()
        } else {
          window.location.assign(redirect)
        }
      }
    } catch (error: any) {
      setIsSubmitting(false)
      handleError("Terjadi kesalahan. Silahkan coba lagi")
    }
  }

  function handleGoogleError(res: any): void {
    console.log(res)
    // console.log(res)
  }

  return (
    <GoogleLogin
      clientId={process.env.GOOGLE_CLIENT_ID || process.env.HARISENIN_GOOGLE_CLIENT_ID || ""}
      render={(renderProps) => (
        <button
          disabled={isSubmitting}
          onClick={renderProps.onClick}
          className={clsx(
            flex_center,
            "relative px-4 py-[22px] h-[50px] text-grey-69 w-full border border-grey-69 rounded"
          )}
        >
          <>
            {isSubmitting ? (
              <Spinner />
            ) : (
              <>
                <Image
                  src="https://pngimg.com/uploads/google/google_PNG19635.png"
                  alt="google"
                  className="h-7 absolute w-auto left-[10%]"
                  width={40}
                  height={40}
                />
                <span>Lanjutkan dengan Google</span>
              </>
            )}
          </>
        </button>
      )}
      buttonText="Login"
      onSuccess={handleGoogleLogin}
      onFailure={handleGoogleError}
      cookiePolicy={"single_host_origin"}
    />
  )
}
